function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import filter from 'lodash/filter';
import { useAction, useUrl } from 'hooks';
import history from 'helpers/history';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import App from 'modules/App';
import OrganizationAdmin from 'modules/OrganizationAdmin';
import * as actions from '../../../actions';
import * as constants from '../../../constants';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import OrganizationBox from './OrganizationBox';
const Intro = ({ isOnlyAdmin })=>{
    const message = isOnlyAdmin ? messages.intros.leaveOnlyAdmin : messages.intros.leaveOrganization;
    return /*#__PURE__*/ _jsx("p", {
        className: "modal__info mb-8",
        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, message))
    });
};
const CancelBtn = ({ isOnlyAdmin, isInProgress })=>{
    const onClose = useAction(App.actions.closeModal);
    return /*#__PURE__*/ _jsx("div", {
        className: `col-${isOnlyAdmin ? 12 : 6}`,
        children: /*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            labelMessage: App.messages.buttons[isOnlyAdmin ? 'close' : 'cancel'],
            className: cn('btn--block', {
                'btn--filled': isOnlyAdmin
            }),
            isDisabled: isInProgress,
            onClick: onClose
        })
    });
};
const SubmitBtn = ({ organizationMembership, isOnlyAdmin, isInProgress })=>{
    if (isOnlyAdmin) {
        return null;
    }
    const onSubmit = useAction(actions.leaveOrganization, organizationMembership);
    return /*#__PURE__*/ _jsx("div", {
        className: "col-6",
        children: /*#__PURE__*/ _jsx(Button, {
            styleModifier: "danger",
            className: "btn--block btn--filled",
            labelMessage: messages.buttons.leaveOrganization,
            isInProgress: isInProgress,
            onClick: onSubmit
        })
    });
};
const Actions = ({ organizationMembership, isOnlyAdmin, isInProgress })=>/*#__PURE__*/ _jsxs("div", {
        className: "row",
        children: [
            /*#__PURE__*/ _jsx(CancelBtn, {
                isOnlyAdmin: isOnlyAdmin,
                isInProgress: isInProgress
            }),
            /*#__PURE__*/ _jsx(SubmitBtn, {
                organizationMembership: organizationMembership,
                isOnlyAdmin: isOnlyAdmin,
                isInProgress: isInProgress
            })
        ]
    });
const LeaveOrganizationModal = ({ organizationMembership })=>{
    const isInProgress = useSelector(selectors.isLeaveOrganizationInProgress);
    const hasErrors = useSelector(selectors.hasLeaveOrganizationErrors);
    const adminOrganizationMemberships = useSelector(OrganizationAdmin.selectors.organizationMemberships);
    const openModalId = useSelector(App.selectors.modal);
    const prevIsInProgressRef = useRef(isInProgress);
    const isOnlyAdmin = useRef(organizationMembership.isAdmin && organizationMembership.status === 'Active' && filter(adminOrganizationMemberships, {
        isAdmin: true,
        status: 'Active'
    }).length < 2).current;
    const returnUrl = useUrl('organization-memberships');
    const onClose = useAction(App.actions.closeModal);
    useEffect(()=>{
        if (prevIsInProgressRef.current !== isInProgress) {
            if (!isInProgress && !hasErrors) {
                history.push(returnUrl);
            }
            prevIsInProgressRef.current = isInProgress;
        }
    }, [
        isInProgress
    ]);
    const message = isOnlyAdmin ? messages.headers.leaveOnlyAdmin : messages.headers.leaveOrganization;
    return /*#__PURE__*/ _jsxs(Modal, {
        modalId: constants.LEAVE_MODAL,
        openModalId: openModalId,
        headerMessage: message,
        onClose: onClose,
        children: [
            /*#__PURE__*/ _jsx(Intro, {
                isOnlyAdmin: isOnlyAdmin
            }),
            /*#__PURE__*/ _jsx(OrganizationBox, {
                organizationMembership: organizationMembership
            }),
            /*#__PURE__*/ _jsx(Actions, {
                organizationMembership: organizationMembership,
                isOnlyAdmin: isOnlyAdmin,
                isInProgress: isInProgress
            })
        ]
    });
};
export default LeaveOrganizationModal;
